import React from 'react';
import { PageProps } from '../types';

const Page: React.FC<PageProps> = ({ children, showFooter = true, className = '' }) => {
  return (
    <div className={`page ${className}`}>
      {children}
      {showFooter && (
        <div className="page-footer">
          Medicina preventiva, personalizada y longevidad.
        </div>
      )}
    </div>
  );
};

export default Page;
